import {
    LOAD_ORDER_DETAILS_SUCCESS,
    CLEAR_ORDER_DETAILS,
    LOAD_RESTAURANT_DETAILS_SUCCESS,
    LOAD_REFUND_HISTORY_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = {
    order: {},
    refunds: {},
    restaurantDetails: {}
}


export default (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_ORDER_DETAILS_SUCCESS:
            return {...state, order: action.payload};
        case LOAD_REFUND_HISTORY_SUCCESS:
            return {...state, refunds: action.payload};
        case LOAD_RESTAURANT_DETAILS_SUCCESS:
            return {...state, restaurantDetails: action.payload};
        case CLEAR_ORDER_DETAILS:
            return INITIAL_STATE;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/orders/OrderDetailsReducer.js